import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, /*#__PURE__*/_toDisplayString('Club de procedencia'), -1)
const _hoisted_10 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t('acrd1')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('acrd5')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                prop: "acondition",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.acondition,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.acondition) = $event)),
                    filterable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCondition, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lstc-${index}`,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form_item, {
                prop: "faculty",
                rules: [
                            {
                                required: true,
                                message: 'Este campo es requerido',
                                trigger: ['blur', 'change'],
                            },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.faculty,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.faculty) = $event)),
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}